import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import { Message } from 'element-ui'

var instance = axios.create({
    //headers: {'Content-type': 'application/x-www-form-urlencoded'},
    transformRequest: [function (data, headers) {
        // Do whatever you want to transform the data
        return qs.stringify(data)
    }]
})

instance.interceptors.response.use(res => {
    if(res.data.code === 500 && res.data.message === '服务内部异常'){
        /*if (confirm("检测到您可能未登录，是否跳转到登录页面？") == true) {
            // 跳转到登录页面
            router.push({
                path: "/login"
            })
        } else {

        }*/
        Message({
            message: res.data.message,
            type: 'error'
        })
    }else if(res.data.code === -999 && res.data.message === '用户未登录'){
        // 跳转到登录页面
        router.push({
            path: "/login"
        })
    }
    return res.data
}, err => {
    return Promise.reject(err)
})

Vue.prototype.$axios = instance
